import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = [
  "MATTERS_FETCH",
  "MATTERS_CLEAR",
  "MATTER_CREATE",
  "MATTER_ADD_DOCUMENTS",
  "MATTER_FETCH",
  "MATTER_CLEAR",
  "MATTER_DELETE",
  "MATTER_RENAME",
  "MATTER_UPDATE_CONTEXT",
  "DC_DOCUMENT_REFRESH",
] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type MattersActionTypes = ActionTypes<ActionType>;

export default actionTypes as MattersActionTypes;
